// frontend/lib/hooks/useWithdrawApplication.ts
"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiPut } from "../apiClient";

// =============================================================================
// Types
// =============================================================================

export interface WithdrawApplicationResponse {
  id: string;
  status: string;
  message?: string;
}

// =============================================================================
// Withdraw Application Mutation
// =============================================================================

export function useWithdrawApplication() {
  const qc = useQueryClient();

  return useMutation<
    WithdrawApplicationResponse,
    Error,
    { applicationId: string }
  >({
    mutationFn: async ({ applicationId }) => {
      return apiPut<WithdrawApplicationResponse>(
        `/applications/${applicationId}/withdraw`,
        {}
      );
    },
    onSuccess: () => {
      // Invalidate nurse applications to refresh the list
      qc.invalidateQueries({ queryKey: ["nurse-applications"] });
      qc.invalidateQueries({ queryKey: ["application"] });
    },
  });
}
